var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"pagedata",domProps:{"innerHTML":_vm._s(_vm.pageData)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }